<template>
  <Content>

    <label
      v-if="$store.getters.identificationClient.length == 14">Você está conectado a empresa:
      {{ $store.getters.nameClient }} -
      {{ $store.getters.identificationClient| mask('##.###.###/####-##') }}
    </label>
    <label
      v-else>Você está conectado a empresa:
      {{ $store.getters.nameClient }} -
      {{ $store.getters.identificationClient| mask('###.###.###-##') }}
    </label>

    <div
      v-if="isLoading"
      class="md-card-graph-total loading-total">
      <Spinner
        name="line-scale-pulse-out-rapid"
        color="#448aff"
        no-fade-in/>
        </Spinner>
    </div>

    <div
      v-if="!isLoading"
      class="md-layout md-gutter">
      <div
        class="md-layout-item md-size-35"
        style="margin-top: 25px; margin-left: 5px;">
        <date-picker
          v-model="dateIni"
          lang="pt-br"
          format="DD/MM/YYYY"
          width="150"
          placeholder="De"/>
        <date-picker
          v-model="dateEnd"
          lang="pt-br"
          format="DD/MM/YYYY"
          width="150"
          placeholder="Até"
          @input="setItens()"/>
        <md-tooltip md-direction="bottom">
          Após informar os dois campos, o filtro será feito
        </md-tooltip>
      </div>
      <div class="md-layout-item md-size-20 filter-model">
        <md-field>
          <md-select
            id="spedType"
            v-model="spedType"
            name="spedType"
            placeholder="Modelo Eletrônico"
            @input="setItens()">
            <md-option value="1">ICMS IPI</md-option>
            <md-option value="2">PIS COFINS</md-option>
          </md-select>
          <md-tooltip md-direction="bottom">Filtrar pelo tipo de Documento</md-tooltip>
        </md-field>
      </div>
    </div>
    <md-table
      v-if="!isLoading"
      v-model="getSped.data"
      md-card
      class="md-card-sped"
      @md-selected="onSelect">
      <md-table-toolbar>
        <label class="title-card-requests">Arquivos Fiscais - Sped</label>
      </md-table-toolbar>

      <md-table-empty-state
        :md-description="`Nenhum arquivo encontrado`">
        <div
          class="loading-speds"
          align="center"/>
      </md-table-empty-state>

      <md-table-toolbar
        slot="md-table-alternate-header"
        slot-scope="{ count }">
        <div class="md-toolbar-section-start">{{ getAlternateLabel(count) }}</div>

        <div class="md-toolbar-section-end">
          <md-button
            class="md-icon-button"
            @click="donwloadSped()">
            <md-icon>cloud_download</md-icon>
          </md-button>
        </div>
      </md-table-toolbar>

      <md-table-row
        slot="md-table-row"
        slot-scope="{ item }"
        md-selectable="multiple"
        md-auto-select>
        <md-table-cell md-label="Data Inicial">{{ formatDate(item.dateIni) }}</md-table-cell>
        <md-table-cell md-label="Data Final">{{ formatDate(item.dateEnd) }}</md-table-cell>
        <md-table-cell
          v-if="item.spedType === ICMSIPI"
          md-label="Arquivo"><label class="label-green">ICMS-IPI</label></md-table-cell>
        <md-table-cell
          v-else-if="item.spedType === PISCOFINS"
          md-label="Arquivo"><label class="label-red">PIS-COFINS</label></md-table-cell>
      </md-table-row>
    </md-table>

    <Pagination
      v-if="!isLoading && getSped.total > 0"
      :total="getSped.total"
      :current_page="getPage"
      :itens-per-page="getSped.count"
      :offset="offset"
      :itens-page="getMaxSpedResults"
      @next="onChangePage"/>

  </Content>
</template>
<script>
import moment from 'moment';
import swal from 'sweetalert';
import DatePicker from 'vue2-datepicker';
import { ICMSIPI, PISCOFINS } from '../../public/api/spedType';
import Content from '../public/Content.vue';
import Pagination from '../../public/pagination/Pagination.vue';

export default {
  name: 'Speds',
  components: {
    Content,
    moment,
    Pagination,
    DatePicker,
  },
  data() {
    return {
      selected: [],
      offset: 3,
      spedType: null,
      dateIni: null,
      dateEnd: null,
    };
  },
  computed: {
    getSped() {
      return this.$store.getters.getSped
    },
    getPage() {
      return this.$store.getters.getPage
    },
    getMaxSpedResults() {
      return this.$store.getters.getMaxSpedResults
    },
    isLoading() {
      return this.$store.getters.isLoading
    },
    ICMSIPI() {
      return ICMSIPI
    },
    PISCOFINS() {
      return PISCOFINS
    }
  },
  created() {
    this.$store.commit('SET_LOADING_STATUS', true)
    this.$store.dispatch('fetchSped')
  },
  methods: {

    onSelect(items) {
      this.selected = items
    },

    getAlternateLabel(count) {
      let plural = ''

      if (count > 1) {
        plural = 's'
      }

      return `${count} Arquivo${plural} selecionado${plural}`
    },

    setItens() {
      const data = {
        identification: this.$store.getters.identificationClient,
        page: 1,
        maxResults: this.$store.getters.getMaxSpedResults,
      }

      if (this.dateIni != null && this.dateEnd != null) {
        data.dateIni = moment(this.dateIni).format('YYYY-MM-DD')
        data.dateEnd = moment(this.dateEnd).format('YYYY-MM-DD')
      }

      if (this.spedType) {
        data.spedType = this.spedType
      }

      this.$store.commit('SET_SPED_FILTERED', data)
      this.$store.dispatch('getSpedsFilter')
    },

    onChangePage(page) {
      this.selected = []
      this.$store.commit('SET_PAGE', page)
      this.$store.dispatch('fetchSped')
    },

    donwloadSped() {
      swal({
        title: 'Deseja realizar o download?',
        text: 'Aguarde, pois o download será feito automaticamente!',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Cancelar',
            value: 'cancel',
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            visible: true,
            closeModal: false
          }
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      })
        .then((value) => {
          if (value === 'cancel') {
            swal.close()
            swal.stopLoading()
            return
          }

          for (let i = 0; i < this.selected.length; i++) {
            const link = document.createElement('a')
            link.href = this.selected[i].spedFile
            link.setAttribute('target', '_blank')
            link.click()
          }

          swal.stopLoading()
          swal.close()
        });
    },

    formatDate(value) {
      return moment(String(value)).format('DD/MM/YYYY')
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/accountant/speds/Speds.vue